import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const calculateChartPercantage = (props) => {
    const data = [
        { name: 'Group A', value: Number(props) },
        { name: 'Group B', value: 100 - Number(props) }
    ];

    return data;
}

const calculateChartColors = (props) => {
    let COLORS = [];
    if(props < 30){
        COLORS = ['#e14b33', '#e1a196'];
    } else if (props < 90){
        COLORS = ['#fae050', '#e6e3a4'];
    } else {
        COLORS = ['#7ede85', '#d5f7dc'];
    }

    return COLORS;
}

const calculateLevel = (props) => {
    let label = '';
    if(props < 30){
        label = 'Bad'
    } else if (props < 90){
        label = 'Medium'
    } else {
        label = 'Good'
    }
    return label;
}

export const SimplePieChartWithPaddingAngle = (props) => {
    return(
        <ResponsiveContainer width="100%" height={100}>
            <PieChart width={800} height={400}>
                <Pie
                data={calculateChartPercantage(props.value)}
                cx={140}
                cy={80}
                startAngle={180}
                endAngle={0}
                innerRadius={60}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
                // cornerRadius={40}
                // paddingAngle={5}
                // stroke='none'
                >
                {calculateChartPercantage(props.value).map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={calculateChartColors(props.value)[index % calculateChartColors(props.value).length]}/>
                    ))}
                </Pie>
                <text x={144} y={60} textAnchor="middle" dominantBaseline="middle" fontWeight='bold' fontSize='20'>
                    {props.value}%
                </text>
                <text x={144} y={80} textAnchor="middle" dominantBaseline="middle" fontSize='20' fontWeight='10'>
                    {calculateLevel(props.value)}
                </text>
            </PieChart>
        </ResponsiveContainer>
    )
}
